var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg400(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 200,
    viewBox: "0 0 232 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.301 25.3474C183.483 -24.8636 252.232 40.5389 182.624 90.3615L130.301 25.3474Z",
    fill: "url(#paint0_linear_3877_107325)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.511 99.8335C214.511 154.987 169.811 199.679 114.676 199.679C59.5399 199.679 14.8407 154.987 14.8407 99.8335C14.8407 52.7409 47.4444 13.2617 91.3083 2.76531C98.8033 0.953149 106.628 0 114.676 0C119.147 0 123.547 0.294182 127.854 0.870778C176.765 7.30747 214.511 49.1637 214.511 99.8335Z",
    fill: "url(#paint1_linear_3877_107325)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M191.968 61.7543C188.461 41.0203 169.153 22.8752 148.833 21.216C128.513 19.5686 114.888 35.0308 118.394 55.7765C121.901 76.5104 141.209 94.6556 161.529 96.3148C181.849 97.9622 195.474 82.4882 191.968 61.7543Z",
    fill: "url(#paint2_linear_3877_107325)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9434 144.974L101.25 139.385C110.557 131.148 123.088 119.934 132.865 111.038C125.759 105.389 117.428 100.729 109.274 97.4582C97.3437 106.284 78.5886 113.674 73.7057 115.521L70.3524 116.792L69.0581 113.45C63.5869 99.2468 67.8697 92.2688 72.4232 88.9269C80.0005 83.361 93.8139 84.4436 107.945 89.3741C110.192 87.4443 111.71 85.6203 112.169 84.02C112.275 83.6317 112.31 83.3257 112.24 83.0315L85.0247 73.0999L160.174 44.835L161.492 51.9424L112.345 75.3828L116.981 77.0773L117.628 77.9245C119.452 80.325 119.97 83.1257 119.134 86.0322C118.534 88.115 117.17 90.1978 115.263 92.2571C123.217 95.7402 130.948 100.294 137.384 105.425C137.678 105.66 137.972 105.895 138.266 106.131C140.819 103.777 143.008 101.741 144.679 100.141C140.913 98.8703 135.478 97.0816 130.406 95.4695L123.017 93.1043L167.975 57.0494L171.835 63.1566L139.984 90.9509C151.997 94.8694 152.691 95.3636 153.138 95.6813L154.562 96.6933L154.668 98.4584C154.762 100.176 154.797 100.788 143.702 110.991C155.762 122.97 159.833 136.031 154.844 147.622L153.809 150.011L94.9434 144.974ZM138.325 115.862C135.866 118.098 133.03 120.651 129.783 123.582C123.358 129.371 116.887 135.149 112.322 139.208L149.02 142.35C151.903 132.125 145.149 122.522 138.325 115.862ZM92.7785 92.7748C85.8718 91.7275 80.0829 92.2688 76.706 94.7517C73.588 97.0463 72.8938 101.294 74.6352 107.413C83.2009 103.965 93.1785 99.2115 100.709 94.5281C97.9555 93.7515 95.2964 93.1631 92.7785 92.7748Z",
    fill: "url(#paint3_linear_3877_107325)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1436 197.795L116.675 197.607L111.863 190.876L113.616 177.049L41.3374 122.308L108.816 170.119L117.982 172.66L117.381 151.844L107.98 119.566L119.699 151.585L121.064 162.034L129.842 159.022L127.524 151.538L157.457 120.437L129.971 153.08L132.16 161.211L119.146 164.035L121.582 179.685L150.55 179.815L183.248 118.625L154.68 179.556L118.346 183.392L123.923 199.243C123.935 199.266 111.557 201.667 95.1436 197.795Z",
    fill: "url(#paint4_linear_3877_107325)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3269 122.319L113.618 177.061L112.276 187.545L112.123 177.743L41.3269 122.319Z",
    fill: "url(#paint5_linear_3877_107325)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.253 187.628L93.7918 189.523L56.5522 176.19L92.6858 192.135L112.818 190.982L113.253 187.628Z",
    fill: "url(#paint6_linear_3877_107325)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M171.812 172.319L194.603 134.123L231.937 123.803L201.875 158.575L171.812 172.319Z",
    fill: "url(#paint7_linear_3877_107325)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M171.812 172.319L199.38 137.994L231.937 123.803L194.603 134.123L171.812 172.319Z",
    fill: "url(#paint8_linear_3877_107325)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9033 161.646L29.7718 131.263L0.0625 123.05L15.8291 146.984L47.9033 161.646Z",
    fill: "url(#paint9_linear_3877_107325)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9033 161.646L25.9714 134.346L0.0625 123.05L29.7718 131.263L47.9033 161.646Z",
    fill: "url(#paint10_linear_3877_107325)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3877_107325",
    x1: 218.594,
    y1: 2.82011,
    x2: 144.486,
    y2: 68.9095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#034C41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3877_107325",
    x1: 114.673,
    y1: 18.5884,
    x2: 114.673,
    y2: 198.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3877_107325",
    x1: 122.462,
    y1: 85.209,
    x2: 202.378,
    y2: 20.6223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#034C41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3877_107325",
    x1: 112.613,
    y1: 116.553,
    x2: 232.486,
    y2: 28.2351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#034C41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3877_107325",
    x1: 112.288,
    y1: 188.337,
    x2: 112.288,
    y2: 70.6489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#034C41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3877_107325",
    x1: 89.1934,
    y1: 160.72,
    x2: 30.2588,
    y2: 105.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2127,
    stopColor: "#42B3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#034C41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3877_107325",
    x1: 84.9014,
    y1: 188.337,
    x2: 84.9014,
    y2: 70.6488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2127,
    stopColor: "#42B3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#034C41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3877_107325",
    x1: 170.331,
    y1: 166.686,
    x2: 222.005,
    y2: 129.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3877_107325",
    x1: 158.68,
    y1: 162.743,
    x2: 292.866,
    y2: 110.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3877_107325",
    x1: 52.874,
    y1: 174.011,
    x2: 12.8145,
    y2: 127.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3877_107325",
    x1: 34.3128,
    y1: 143.914,
    x2: 113.621,
    y2: 155.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg400);
export default __webpack_public_path__ + "static/media/400.3659616367f8931a0e9216919d196390.svg";
export { ForwardRef as ReactComponent };